import { map, noop } from 'lodash';
import * as React from 'react';
import { useContext } from 'react';
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';
import { SettingsContext } from '../../Context';
import {  LanguageSelector } from '../Language/Language';
import { NavMobileCategory } from '../NavBar/NavBar';
import "./Footer.css";

export const Footer = () => {

    const { locale } = useContext(SettingsContext)

    return(
        <div className="footer-outer-container">
            <div className="footer-top">
                <div className="footer-links">
                    <NavMobileCategory 
                                footer
                                title={"browse"} 
                                items={[
                                    {
                                        title: "All Programs",
                                        link: "/programs",
                                    },
                 
                                    {
                                        title: "Spanish",
                                        action: noop
                                    },
                                    {
                                        title: "My List",
                                    },

                                    {
                                        title: "Search",
                                        link:"/search"
                                    }
                                ]}
                            />
                    <NavMobileCategory 
                        footer
                        title={"Live"} 
                        items={[
                            {
                                title: "Watch Live",
                                link: "/live"
                            },
                            {
                                title: "Schedule",
                                action: noop
                            },
                            {
                                title: "Ways to Watch",
                                action: noop
                            }
                        ]}
                    />
                    <NavMobileCategory 
                        footer
                        title={"About Us"} 
                        items={[
                            {
                                title: "About",
                                action: noop
                            },
                            {
                                title: "Contact",
                                link: "/contact"
                            },
                            {
                                title: "Donate",
                                action: noop
                            },
                            {
                                title: "Help",
                                action: noop
                            },
                        ]}
                    />
                    <NavMobileCategory 
                        footer
                        title={"More"} 
                        items={[
                            {
                                title: "It Is Written",
                                link: 'https://itiswritten.com',
                                external: true
                            },
                            {
                                title: "Escrito Está",
                                link:"https://escritoesta.org",
                                external: true
                            },
                            {
                                title: "My Place With Jesus",
                                link: "https://myplacewithjesus.com/",
                                external: true
                            },
                            {
                                title: "Shop",
                                link: "https://itiswritten.shop/",
                                external: true
                            },
                        ]}
                    />
                </div>
                <LanguageSelector />
            </div>
            <div className="footer-bottom-container">
                <div className="footer-social-icons">
                    <div className="footer-icon"><FaFacebookF size={35} color="white"/></div>
                    <div className="footer-icon"><FaTwitter size={35} color="white"/></div>
                    <div className="footer-icon"><FaInstagram size={35} color="white"/></div>
                    <div className="footer-icon"><FaYoutube size={35} color="white"/></div>
                </div>
                <div className="footer-terms-container">
                    <div>{locale.copywrite}</div>
                    <div className="footer-terms-highlight"><span>{locale.terms}</span></div>
                    <div className="footer-terms-highlight"><span>{locale.privacy}</span></div>
                    <div className="footer-terms-highlight"><span>{locale.privacyCalifornia}</span></div>
                    <div className="footer-terms-highlight"><span>{locale.sitemap}</span></div>
                </div>
            </div>
        </div>
    )
}


